import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../../utils/contants";

export const CompanyDetailsStyled = styled.div`

  .tab-content {
    padding: 12px 36px !important;
  }
  .delete-icon {
    display: flex;
    justify-content: end;
    margin-top: 20px;
  }
  .table-scroll-container {
    .MuiPaper-root {
      height: calc(100vh - 200px);
      overflow-y: auto;
    }
}
  .head-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .linked-companies {
    padding: 12px 36px 0;
  }

  .type {
    padding-bottom: 16px;
    padding-top: 24px;
  }
  .footer {
    padding: 8px 36px;
    position: sticky;
    bottom: 0;
    background: var(--flow-30-neutral-white, #FFF);
    z-index: 1;

    .space-between {
      display: flex;
      justify-content: space-between;
      .created {
        display: grid;
      }
    }
  }
  .no-data {
    border: 1px solid ${COLOUR_CONSTANT.theme.light};
    padding: 36px 14px;
  }
  .noContact {
    display: flex;
    gap: 16px;
    margin-top: 16px;
    justify-content: center;
  }
  .noContact2 {
    display: flex;
    gap: 16px;
    margin-top: 16px;
    justify-content: end;
    .noContactButton {
      color: white;
    }
  }
    /* Add shake animation */
    @keyframes shake {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(-5px);
    }
    50% {
      transform: translateX(5px);
    }
    75% {
      transform: translateX(-5px);
    }
    100% {
      transform: translateX(0);
    }
  }

  .shake {
    animation: shake 0.5s ease;
  }
`;
